export default "__VITE_ASSET__faf3ddf2__"